/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  noResults: {
    id: 'SearchAndBrowse.Category.List.noResults',
    defaultMessage: 'No results found'
  },
  rootsOnlyDescription: {
    id: 'SearchAndBrowse.Category.List.rootsOnly.description',
    defaultMessage: 'Browse the Aurora Parts catalog'
  },
  rootsOnlyName: {
    id: 'SearchAndBrowse.Category.List.rootsOnly.name',
    defaultMessage: 'Parts Search'
  },
  brandsRootName: {
    id: 'SearchAndBrowse.Category.List.brandsRoot.name',
    defaultMessage: 'Brands'
  }
});
